import { Component } from '@theme/component';
import { FilterUpdateEvent, ThemeEvents } from "@theme/events";
import { sectionRenderer } from '@theme/section-renderer';
import { startViewTransition } from '@theme/utilities';

/**
 * Handles updating the breadcrumbs *
 */
class BreadcrumbsList extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('Section ID is required');
    return id;
  }

  /**
   * Request an update to the breadcrumbs when the filters change
   *
   * @param {FilterUpdateEvent} event
   */
  #handleFilterUpdate = (event) => {
    this.#updateSection();
  }

  /**
   * Updates the section
   */
  #updateSection() {
    const viewTransition = !this.closest('dialog');

    if (viewTransition) {
      startViewTransition(() => sectionRenderer.renderSection(this.sectionId), ['product-grid']);
    } else {
      sectionRenderer.renderSection(this.sectionId);
    }
  }
}

if (!customElements.get('breadcrumbs-list')) {
  customElements.define('breadcrumbs-list', BreadcrumbsList);
}
